@if (showSignupErrorBanner) {
  <div class="mb-4">
    <app-edit-permissions-banner
      [bannerType]="BannerType.error"
      [scrollInto]="true"
      (onClose)="closeSignupErrorBanner()"
      data-test-id="sign-up-server-error"
    >
      @if (signUpErrorMessage) {
        {{ signUpErrorMessage }}
      } @else {
        {{ 'account_with_email_already_exists' | translate }}
        <ds-link [rtLink]="'/' + Api.login">{{ 'login_to_your_account' | translate }}</ds-link>
      }
    </app-edit-permissions-banner>
  </div>
}

<form [formGroup]="form">
  <fieldset>
    <legend class="visuallyhidden">{{ 'sign_up_form' | translate }}</legend>
    <div class="mb-4">
      {{ 'form-field-marked-as-required' | translate }}
    </div>

    <div class="row mb-4">
      <div class="col-md-6 mb-4 mb-md-0">
        <ds-input
          [label]="FormField.FIRST_NAME | translate"
          [errorMessage]="firstNameError$ | async"
          [errorState]="(firstNameError$ | async)?.length > 0"
          [required]="true"
          data-test-id="sign-up-first-name"
        >
          <input ds-input-field type="text" [formControlName]="FormField.FIRST_NAME" />
        </ds-input>
      </div>
      <div class="col-md-6">
        <ds-input
          [label]="FormField.LAST_NAME | translate"
          [errorMessage]="lastNameError$ | async"
          [errorState]="(lastNameError$ | async)?.length > 0"
          [required]="true"
          data-test-id="sign-up-last-name"
        >
          <input ds-input-field type="text" [formControlName]="FormField.LAST_NAME" />
        </ds-input>
      </div>
    </div>

    <div class="mb-4">
      <ds-input [label]="FormField.EMAIL | translate" [state]="emailInputState" data-test-id="sign-up-email">
        <input ds-input-field type="email" [formControlName]="FormField.EMAIL" />
      </ds-input>
    </div>

    <div class="mb-4">
      <app-job-function-select
        label="sign_up_role_label"
        placeholder="select_a_role"
        [formControlName]="FormField.ROLE"
        data-test-id="sign-up-role"
        [errorMessage]="roleError$ | async"
        [errorState]="(roleError$ | async)?.length > 0"
      ></app-job-function-select>
    </div>

    @if (externalAuthEnabled === false) {
      <div class="mb-4">
        <app-change-password-from-signup
          [emailToken]="confirmEmailToken"
          [formChangePassword]="form"
        ></app-change-password-from-signup>
      </div>
    }

    <div>
      <button type="button" ds-button [variant]="DsButtonVariants.primary" (click)="onSubmit()" data-test-id="sign-up-submit">
        {{ 'sign_up' | translate }}
      </button>
    </div>
  </fieldset>
</form>
